module.exports = __webpack_public_path__ + "img/sv35.023d6c09.svg";